import { render, staticRenderFns } from "./ChartPageColumn.vue?vue&type=template&id=12f0c7c6&"
import script from "./ChartPageColumn.vue?vue&type=script&lang=ts&"
export * from "./ChartPageColumn.vue?vue&type=script&lang=ts&"
import style0 from "./ChartPageColumn.vue?vue&type=style&index=0&id=12f0c7c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports